module.exports = __webpack_public_path__ + "img/9.57846128.png";